export const changeLineStyle :any = {
  display:'block',
  marginLeft:0,
  float: 'none',
  paddingLeft:'20px',
  paddingRight:0,
  marginTop:'10px'
};
